module.exports = __webpack_public_path__ + "img/contributions10On.d1e1c8f3.svg";